module.exports = __webpack_public_path__ + "images/article-3-cover.jpg";